import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {EvaluateDayEvent} from "@/modules/season/events/EvaluateDayEvent";
import {inject, injectable} from "inversify";
import {Team} from "@/modules/team/entity";
import {BankCategory} from "@/modules/finances/enums";
import {GateTypeEnum} from "@/modules/action-points/enums";
import GateManager from "@/modules/action-points/services/GateManager";

@injectable()
export class PlayerWageEventSubscriber implements EventSubscriber {
  constructor(
    @inject(GateManager) private gateManager: GateManager,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: EvaluateDayEvent, callback: this.onEvaluateDay},
    ];
  }

  async onEvaluateDay(event: EvaluateDayEvent): Promise<void> {
    if (event.season.currentDate.date() !== 15) {
      return;
    }

    console.time('player wages');
    const team = await Team
      .createQueryBuilder('team')
      .leftJoinAndSelect('team.players', 'players')
      .where('team.user = true')
      .getOneOrFail();

    const wages = collect(team.players).sum('wage') as number;

    await this.gateManager.getGate(GateTypeEnum.BALANCE).currency.forceSubtract(
      wages,
      {
        category: BankCategory.WAGES,
        label: translator.t('player_wages'),
      }
    );
    console.timeEnd('player wages');
  }
}